"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _uiKit = require("@devsta/ui-kit"),
    _ListItem = _interopRequireDefault(require("./ListItem"));

function CaptionListItems(a) {
  var b = a.captions,
      c = a.type;
  return _react["default"].createElement(_react.Fragment, {
    key: "".concat(c, "-CAPTIONS")
  }, _react["default"].createElement(_uiKit.Text, {
    label: !0
  }, "".concat(c, " Captions")), b.map(function (a) {
    var b = a.captionValue;
    return _react["default"].createElement(_ListItem["default"], {
      key: "".concat(c, "-").concat(b.label),
      iconName: b.prefix,
      text: b.label,
      price: b.cost
    });
  }), _react["default"].createElement("hr", {
    className: "list-items__horizontal-line"
  }));
}

var _default = (0, _react.memo)(CaptionListItems);

exports["default"] = _default;